import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {app} from "@/app";
import {formatShopifyPrice} from "@/helpers";

export class Product extends AbstractStorageModule {
  product: null|Record<string, any> = null;

  get payload(): null|Record<string, any> {
    if(!this.product) return null;

    return {
      product_id: this.product.id,
      product_variant_id: this.selectedProductVariantId
    }
  }

  resolve() {
    this.product = null;

    // we can get current order only from order page
    if (app.storage.shopify.page.type === app.storage.shopify.page.types.product) {
      /**
       * on product page window.ShopifyAnalytics.meta.product will contain product
       */
      // @ts-ignore
      this.product = window?.ShopifyAnalytics?.meta?.product ?? null;
    }
  }

  get selectedProductVariantId(): null|number {
    // @ts-ignore
    let result = window?.ShopifyAnalytics?.meta?.selectedVariantId ?? null
    if(result != null) {
      result = parseInt(result);
    }
    return result;
  }
}
